import _ from 'underscore';

interface IOptions {
  repairMode: boolean;
  videoList: {
    status: string;
    idString: string;
    text: string;
  }[];

  videoRepository: any;

  events: {
    onProgress: Function;
    onTokenUpdate: Function
    onResponse: Function
    onError: Function
    onFinally: Function
  }
}

export async function handleFileRead(file: File, options: IOptions) {
  const {
    repairMode,
    videoList,
    videoRepository,
    events: {
      onProgress,
      onTokenUpdate,
      onResponse,
      onError,
      onFinally,
    },
  } = options;

  const invalidVideo = _.find(videoList, _video => _video.status === 'Failed');

  const postVideoByFilePromise = repairMode && invalidVideo ? videoRepository.replaceVideoByBlob({
    file,
    id: invalidVideo.idString,
    description: invalidVideo.text,
    onProgress,
  }) : videoRepository.postVideoByFile({
    description: file.name,
    file,
    onProgress,
  });

  try {
    const token = await postVideoByFilePromise;

    const response = await onTokenUpdate(token);

    onResponse(response);
  } catch (error) {
    onError(error);
  } finally {
    onFinally();
  }
}
